import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

interface OnboardingStepSkeletonProps {
  fieldCount: number;
  showBackButton?: boolean;
  maxWidthClassName?: string;
}

export function OnboardingStepSkeleton({
  fieldCount,
  showBackButton = false,
  maxWidthClassName = "max-w-2xl",
}: OnboardingStepSkeletonProps) {
  return (
    <div className={cn("mx-auto w-full px-4 py-8", maxWidthClassName)}>
      <div className="space-y-8 rounded-[1.75rem] border border-border/70 bg-card/95 p-8 shadow-sm">
        <div className="space-y-3">
          <Skeleton className="h-8 w-56" />
          <Skeleton className="h-4 w-72 max-w-full" />
        </div>
        <div className="space-y-5">
          {Array.from({ length: fieldCount }).map((_, index) => (
            <Skeleton
              key={index}
              className={cn("w-full rounded-xl", index % 3 === 2 ? "h-24" : "h-12")}
            />
          ))}
        </div>
        <div className="flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
          {showBackButton && <Skeleton className="h-11 w-28 rounded-xl" />}
          <Skeleton className="h-11 w-36 rounded-xl" />
        </div>
      </div>
    </div>
  );
}
